import { type MessageInstance } from "antd/es/message/interface";

import { privateAPI } from "../../../_config/constants";
import { errorHandler } from "../../_utils";
import { type PolicyFormType, store } from "..";
import {
  setLegislationLoading,
  setLegislations,
} from "../slices/legislationSlice";
export const getLegislations = async (notify: MessageInstance) => {
  try {
    store.dispatch(setLegislationLoading(true));
    const response = await privateAPI.get("/legislation-link");
    if (response) {
      store.dispatch(setLegislationLoading(false));
      store.dispatch(setLegislations(response.data));
    }
    return response;
  } catch (error) {
    store.dispatch(setLegislationLoading(false));
    console.error("Get Legislation Error:", error);
    errorHandler(error, notify);
  }
};

export const createLegislation = async (
  notify: MessageInstance,
  payload: PolicyFormType,
) => {
  try {
    store.dispatch(setLegislationLoading(true));
    const { data } = await privateAPI.post("/legislation-link", payload);
    notify.success("Legislation created successfully!");
    return data;
  } catch (error) {
    console.error("Create Legislation Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setLegislationLoading(false));
  }
};

export const updateLegislation = async (
  notify: MessageInstance,
  payload: PolicyFormType,
) => {
  try {
    if (!payload.id) return;
    store.dispatch(setLegislationLoading(true));
    const { data } = await privateAPI.put(
      `/legislation-link/${payload.id}`,
      payload,
    );
    notify.success("Legislation updated successfully!");
    return data;
  } catch (error) {
    console.error("Update Legislation Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setLegislationLoading(false));
  }
};

export const deleteLegislation = async (
  notify: MessageInstance,
  id: string,
  getData = false,
) => {
  try {
    store.dispatch(setLegislationLoading(true));
    const response = await privateAPI.delete(`/legislation-link/${id}`);
    if (response) {
      getData && (await getLegislations(notify));
    }
    notify.success("Legislation deleted successfully!");
    return response;
  } catch (error) {
    console.error("Delete Legislation Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setLegislationLoading(false));
  }
};

export const uploadLegislationCsv = async (
  notify: MessageInstance,
  payload: FormData,
) => {
  try {
    store.dispatch(setLegislationLoading(true));
    const response = await privateAPI.post(
      `/legislation-link/bulk-upload`,
      payload,
    );
    if (response) {
      await getLegislations(notify);
    }
    notify.success("Legislations uploaded successfully!");
    return response;
  } catch (error) {
    console.error("Legislations upload Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setLegislationLoading(false));
  }
};
